var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card",on:{"click":_vm.onClick}},[_vm._t("default"),(_vm.href)?void 0:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }